import { Formik, Form, Field } from 'formik';
import { Plus } from 'lucide-react';
import { SchemaOf, object, string } from 'yup';
import { useReducer } from 'react';

import { Button } from '@@/buttons';
import { FormControl } from '@@/form-components/FormControl';
import { Input } from '@@/form-components/Input';

export function AddEntryForm({
  onSubmit,
  isLoading,
}: {
  onSubmit: (entry: string) => void;
  isLoading: boolean;
}) {
  const [formKey, clearForm] = useReducer((state: number) => state + 1, 0);

  const initialValues = { entry: '' };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validation}
      key={formKey}
    >
      {({ errors, isValid, dirty }) => (
        <Form className="form-horizontal">
          <div className="flex w-full items-start gap-4">
            <FormControl label="Entry" errors={errors.entry} className="flex-1">
              <Field as={Input} name="entry" />
            </FormControl>

            <Button
              type="submit"
              data-cy="allowlist-add-entry-button"
              icon={Plus}
              disabled={!dirty || !isValid || isLoading}
            >
              Add entry
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );

  function handleSubmit(values: typeof initialValues) {
    clearForm();
    onSubmit(values.entry);
  }
}

function validation(): SchemaOf<{ entry: string }> {
  return object({
    entry: string().required('Entry is required'),
  });
}
